<template>
	<div ref="labelRef" class="cursor-label" :class="{ visible: isVisible }">
		<Transition name="label-text" mode="out-in">
			<span class="cursor-label-text" :key="textKey">{{ currentText }}</span>
		</Transition>
	</div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const labelRef = ref(null)
const isVisible = ref(false)
const currentText = ref('')
const textKey = ref(0)

let mouseX = 0
let mouseY = 0

const updatePosition = () => {
	if (labelRef.value) {
		labelRef.value.style.left = `${mouseX + 15}px`
		labelRef.value.style.top = `${mouseY + 15}px`
	}
}

const checkElement = () => {
	const el = document.elementFromPoint(mouseX, mouseY)
	if (!el) {
		hide()
		return
	}

	const target = el.closest('[data-cursor-label]')

	if (target) {
		const newText = target.dataset.cursorLabel
		if (!isVisible.value) {
			show(newText)
		} else if (currentText.value !== newText) {
			currentText.value = newText
			textKey.value++
		}
	} else {
		hide()
	}
}

const show = (text) => {
	currentText.value = text
	textKey.value++
	updatePosition()
	isVisible.value = true
}

const hide = () => {
	if (!isVisible.value) return
	isVisible.value = false
}

const onMouseMove = (e) => {
	mouseX = e.clientX
	mouseY = e.clientY
	updatePosition()
	checkElement()
}

const onScroll = () => {
	checkElement()
}

onMounted(() => {
	document.addEventListener('mousemove', onMouseMove)
	document.addEventListener('scroll', onScroll, true)
})

onBeforeUnmount(() => {
	document.removeEventListener('mousemove', onMouseMove)
	document.removeEventListener('scroll', onScroll, true)
})
</script>

<style scoped>
.cursor-label {
	position: fixed;
	z-index: 10001;
	pointer-events: none;
	background: rgb(var(--color-accent));
	// Подпись поверх акцентной заливки: --text-on-accent, а не --text-inverse —
	// заливка одна в обеих темах, значит и контрастный к ней цвет один.
	color: rgb(var(--text-on-accent));
	padding: 0.75rem 1.25rem;
	font-size: 0.875rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	white-space: nowrap;
	border-radius: 0.25rem;
	opacity: 0;
	scale: 0.8;
	overflow: hidden;
	transition: opacity 0.2s, scale 0.2s;
}

.cursor-label.visible {
	opacity: 1;
	scale: 1;
}

.cursor-label-text {
	display: block;
}

.label-text-enter-active,
.label-text-leave-active {
	transition: transform 0.12s, opacity 0.12s;
}

.label-text-enter-from {
	transform: translateY(8px);
	opacity: 0;
}

.label-text-leave-to {
	transform: translateY(-8px);
	opacity: 0;
}
</style>
